// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Time_Local from "../Data.Time.Local/index.js";
import * as Data_UTCTime from "../Data.UTCTime/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Locales from "../Restaumatic.Locales/index.js";
import * as Restaumatic_Orders_Checkout_Types from "../Restaumatic.Orders.Checkout.Types/index.js";
import * as Restaumatic_Orders_Payments_Dotpay_Types from "../Restaumatic.Orders.Payments.Dotpay.Types/index.js";
import * as Restaumatic_Orders_Payments_Types from "../Restaumatic.Orders.Payments.Types/index.js";
import * as Restaumatic_Orders_RPC_Sites_OrderInfo from "../Restaumatic.Orders.RPC.Sites.OrderInfo/index.js";
import * as Restaumatic_Orders_Types from "../Restaumatic.Orders.Types/index.js";
import * as Restaumatic_Orders_Types_FulfillmentMethodType from "../Restaumatic.Orders.Types.FulfillmentMethodType/index.js";
import * as Restaumatic_Orders_Types_PaymentMethod from "../Restaumatic.Orders.Types.PaymentMethod/index.js";
import * as Restaumatic_Promotions_Loyalty_Types_UserLoyalty from "../Restaumatic.Promotions.Loyalty.Types.UserLoyalty/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
import * as Restaumatic_TypesGen from "../Restaumatic.TypesGen/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var Errors = /* #__PURE__ */ (function () {
    function Errors(value0) {
        this.value0 = value0;
    };
    Errors.create = function (value0) {
        return new Errors(value0);
    };
    return Errors;
})();
var Redirect = /* #__PURE__ */ (function () {
    function Redirect(value0) {
        this.value0 = value0;
    };
    Redirect.create = function (value0) {
        return new Redirect(value0);
    };
    return Redirect;
})();
var ExternalRedirect = /* #__PURE__ */ (function () {
    function ExternalRedirect(value0) {
        this.value0 = value0;
    };
    ExternalRedirect.create = function (value0) {
        return new ExternalRedirect(value0);
    };
    return ExternalRedirect;
})();
var PaymentForm = /* #__PURE__ */ (function () {
    function PaymentForm(value0) {
        this.value0 = value0;
    };
    PaymentForm.create = function (value0) {
        return new PaymentForm(value0);
    };
    return PaymentForm;
})();
var PlaceOrderRequest = function (x) {
    return x;
};
var Placed = /* #__PURE__ */ (function () {
    function Placed() {

    };
    Placed.value = new Placed();
    return Placed;
})();
var WaitingForPayment = /* #__PURE__ */ (function () {
    function WaitingForPayment() {

    };
    WaitingForPayment.value = new WaitingForPayment();
    return WaitingForPayment;
})();
var WaitingForDispatch = /* #__PURE__ */ (function () {
    function WaitingForDispatch(value0) {
        this.value0 = value0;
    };
    WaitingForDispatch.create = function (value0) {
        return new WaitingForDispatch(value0);
    };
    return WaitingForDispatch;
})();
var WaitingForConfirmation = /* #__PURE__ */ (function () {
    function WaitingForConfirmation() {

    };
    WaitingForConfirmation.value = new WaitingForConfirmation();
    return WaitingForConfirmation;
})();
var Completed = /* #__PURE__ */ (function () {
    function Completed(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Completed.create = function (value0) {
        return function (value1) {
            return new Completed(value0, value1);
        };
    };
    return Completed;
})();
var Cancelled = /* #__PURE__ */ (function () {
    function Cancelled(value0) {
        this.value0 = value0;
    };
    Cancelled.create = function (value0) {
        return new Cancelled(value0);
    };
    return Cancelled;
})();
var GetOrderSummaryResponse = function (x) {
    return x;
};
var GetOrderSummaryRequest = function (x) {
    return x;
};
var GetCheckoutInfoRequest = function (x) {
    return x;
};
var FulfillmentTimeChoice = function (x) {
    return x;
};
var CheckoutInfo = function (x) {
    return x;
};
var eqPlaceOrderResponse = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Errors && y instanceof Errors) {
                return Data_Eq.eq(Data_Eq.eqArray(Data_Eq.eqString))(x.value0)(y.value0);
            };
            if (x instanceof Redirect && y instanceof Redirect) {
                return Data_Eq.eq(Restaumatic_Orders_Types.eqOrderUUID)(x.value0.orderUUID)(y.value0.orderUUID) && x.value0.url === y.value0.url;
            };
            if (x instanceof ExternalRedirect && y instanceof ExternalRedirect) {
                return Data_Eq.eq(Restaumatic_Orders_Types.eqOrderUUID)(x.value0.orderUUID)(y.value0.orderUUID) && x.value0.url === y.value0.url;
            };
            if (x instanceof PaymentForm && y instanceof PaymentForm) {
                return Data_Eq.eq(Restaumatic_Orders_Payments_Types.eqForm)(x.value0.form)(y.value0.form) && Data_Eq.eq(Restaumatic_Orders_Types.eqOrderUUID)(x.value0.orderUUID)(y.value0.orderUUID);
            };
            return false;
        };
    }
};
var eqPlaceOrderRequest = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Restaumatic_Orders_Checkout_Types.eqCheckoutRequest)(x.checkout)(y.checkout) && x.origin === y.origin && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Orders_Payments_Types.eqPaymentRequest))(x.payment)(y.payment) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Orders_Payments_Dotpay_Types.eqChannelId))(x.paymentChannel)(y.paymentChannel);
        };
    }
};
var eqOrderSummaryState = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Placed && y instanceof Placed) {
                return true;
            };
            if (x instanceof WaitingForPayment && y instanceof WaitingForPayment) {
                return true;
            };
            if (x instanceof WaitingForDispatch && y instanceof WaitingForDispatch) {
                return x.value0.openAt === y.value0.openAt;
            };
            if (x instanceof WaitingForConfirmation && y instanceof WaitingForConfirmation) {
                return true;
            };
            if (x instanceof Completed && y instanceof Completed) {
                return Data_Eq.eq(Data_Time_Local.eqTZLabel)(x.value0)(y.value0) && Data_Eq.eq(Data_UTCTime.eqUTCTime)(x.value1)(y.value1);
            };
            if (x instanceof Cancelled && y instanceof Cancelled) {
                return Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.value0)(y.value0);
            };
            return false;
        };
    }
};
var eqGetOrderSummaryResponse = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Restaumatic_Orders_RPC_Sites_OrderInfo.eqOrderInfo)(x.orderInfo)(y.orderInfo) && x.restaurantAddressCity === y.restaurantAddressCity && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.restaurantAddressPostCode)(y.restaurantAddressPostCode) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.restaurantAddressStreet)(y.restaurantAddressStreet) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.restaurantApetiloImage)(y.restaurantApetiloImage) && Data_Eq.eq(Restaumatic_Restaurant_Types_Id.eqRestaurantId)(x.restaurantId)(y.restaurantId) && x.restaurantName === y.restaurantName && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.restaurantPhones)(y.restaurantPhones) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.restaurantSlug)(y.restaurantSlug) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.siteName)(y.siteName) && Data_Eq.eq(eqOrderSummaryState)(x.state)(y.state) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Promotions_Loyalty_Types_UserLoyalty.eqUserLoyalty))(x.userLoyalty)(y.userLoyalty);
        };
    }
};
var eqGetOrderSummaryRequest = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Restaumatic_Orders_Types.eqOrderUUID)(x.orderId)(y.orderId);
        };
    }
};
var eqGetCheckoutInfoRequest = {
    eq: function (x) {
        return function (y) {
            return x.isQrWaiterOrder === y.isQrWaiterOrder && Data_Eq.eq(Restaumatic_Locales.eqLocale)(x.locale)(y.locale) && Data_Eq.eq(Restaumatic_Restaurant_Types_Id.eqRestaurantId)(x.restaurantId)(y.restaurantId);
        };
    }
};
var eqFulfillmentTimeChoice = {
    eq: function (x) {
        return function (y) {
            return x.label === y.label && Data_Eq.eq(Data_Maybe.eqMaybe(Data_UTCTime.eqUTCTime))(x.value)(y.value);
        };
    }
};
var eqCheckoutInfo = {
    eq: function (x) {
        return function (y) {
            return x.companyCity === y.companyCity && x.companyName === y.companyName && Data_Eq.eq(Restaumatic_TypesGen.eqCountry)(x.country)(y.country) && Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Orders_Types_FulfillmentMethodType.eqFulfillmentMethodType))(x.fulfillmentMethods)(y.fulfillmentMethods) && Data_Eq.eq(Data_Eq.eqArray(eqFulfillmentTimeChoice))(x.fulfillmentTimes)(y.fulfillmentTimes) && x.paylanePublicApiKey === y.paylanePublicApiKey && Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Orders_Types_PaymentMethod.eqPaymentMethod))(x.paymentMethods)(y.paymentMethods) && x.restaurantName === y.restaurantName && x.signedIn === y.signedIn;
        };
    }
};
var rpcMethodNamePlaceOrderRequest = {
    rpcMethodName: function (v) {
        return "PlaceOrderRequest";
    }
};
var rpcMethodNameGetOrderSummaryRequest = {
    rpcMethodName: function (v) {
        return "GetOrderSummaryRequest";
    }
};
var rpcMethodNameGetCheckoutInfoRequest = {
    rpcMethodName: function (v) {
        return "GetCheckoutInfoRequest";
    }
};
var newtypePlaceOrderRequest = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeGetOrderSummaryResponse = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeGetOrderSummaryRequest = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeGetCheckoutInfoRequest = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeFulfillmentTimeChoice = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeCheckoutInfo = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldPlaceOrderRequest = function (dictHasField) {
    return dictHasField;
};
var hasFieldGetOrderSummaryResponse = function (dictHasField) {
    return dictHasField;
};
var hasFieldGetOrderSummaryRequest = function (dictHasField) {
    return dictHasField;
};
var hasFieldGetCheckoutInfoRequest = function (dictHasField) {
    return dictHasField;
};
var hasFieldFulfillmentTimeChoice = function (dictHasField) {
    return dictHasField;
};
var hasFieldCheckoutInfo = function (dictHasField) {
    return dictHasField;
};
var genericPlaceOrderResponse = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Errors(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new Redirect(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new ExternalRedirect(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return new PaymentForm(x.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.RPC.Sites.Types (line 52, column 1 - line 52, column 91): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Errors) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof Redirect) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof ExternalRedirect) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof PaymentForm) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.RPC.Sites.Types (line 52, column 1 - line 52, column 91): " + [ x.constructor.name ]);
    }
};
var showPlaceOrderResponse = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPlaceOrderResponse)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString)))({
        reflectSymbol: function () {
            return "Errors";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "orderUUID";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "url";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Restaumatic_Orders_Types.showOrderUUID))))({
        reflectSymbol: function () {
            return "Redirect";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "orderUUID";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "url";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Restaumatic_Orders_Types.showOrderUUID))))({
        reflectSymbol: function () {
            return "ExternalRedirect";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "form";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "orderUUID";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Orders_Types.showOrderUUID))(Restaumatic_Orders_Payments_Types.showForm))))({
        reflectSymbol: function () {
            return "PaymentForm";
        }
    })))))
};
var unscrambleDecodePlaceOrderResponse = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPlaceOrderResponse)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "Errors";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(/* #__PURE__ */ Unscramble.decodeArray1(Unscramble.decodeString1))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "Redirect";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "orderUUID";
        }
    })(Restaumatic_Orders_Types.unscrambleDecodeOrderUUID)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "url";
        }
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "ExternalRedirect";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "orderUUID";
        }
    })(Restaumatic_Orders_Types.unscrambleDecodeOrderUUID)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "url";
        }
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "PaymentForm";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "form";
        }
    })(Restaumatic_Orders_Payments_Types.unscrambleDecodeForm)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "orderUUID";
        }
    })(Restaumatic_Orders_Types.unscrambleDecodeOrderUUID)(Unscramble.decodeRecordNil)))))))))(Unscramble_Generic.defaultOptions)
};
var genericPlaceOrderRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showPlaceOrderRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPlaceOrderRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "checkout";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "origin";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "payment";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "paymentChannel";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Orders_Payments_Dotpay_Types.showChannelId)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Orders_Payments_Types.showPaymentRequest)))(Data_Show.showString))(Restaumatic_Orders_Checkout_Types.showCheckoutRequest))))({
        reflectSymbol: function () {
            return "PlaceOrderRequest";
        }
    }))
};
var unscrambleDecodePlaceOrderRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPlaceOrderRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "checkout";
        }
    })(Restaumatic_Orders_Checkout_Types.unscrambleDecodeCheckoutRequest)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "origin";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "payment";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Orders_Payments_Types.unscrambleDecodePaymentRequest))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "paymentChannel";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Orders_Payments_Dotpay_Types.unscrambleDecodeChannelId))(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var genericOrderSummaryState = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Placed.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return WaitingForPayment.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new WaitingForDispatch(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return WaitingForConfirmation.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new Completed(x.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))) {
            return new Cancelled(x.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.RPC.Sites.Types (line 30, column 1 - line 30, column 89): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Placed) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof WaitingForPayment) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof WaitingForDispatch) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof WaitingForConfirmation) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof Completed) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))))));
        };
        if (x instanceof Cancelled) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)))));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.RPC.Sites.Types (line 30, column 1 - line 30, column 89): " + [ x.constructor.name ]);
    }
};
var showOrderSummaryState = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericOrderSummaryState)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Placed";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "WaitingForPayment";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "openAt";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))))({
        reflectSymbol: function () {
            return "WaitingForDispatch";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "WaitingForConfirmation";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Time_Local.showTZLabel))(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_UTCTime.showUTCTime)))({
        reflectSymbol: function () {
            return "Completed";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))({
        reflectSymbol: function () {
            return "Cancelled";
        }
    })))))))
};
var unscrambleDecodeOrderSummaryState = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericOrderSummaryState)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Placed";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "WaitingForPayment";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "WaitingForDispatch";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "openAt";
        }
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "WaitingForConfirmation";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgs1(/* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsProd(/* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsArgu(Data_Time_Local.udecodeTZLabel))(/* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsArgu(Data_UTCTime.unscrambleDecodeUTCTime))))({
        reflectSymbol: function () {
            return "Completed";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "Cancelled";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))))))))))(Unscramble_Generic.defaultOptions)
};
var genericGetOrderSummaryResponse = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGetOrderSummaryResponse = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetOrderSummaryResponse)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "orderInfo";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantAddressCity";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantAddressPostCode";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantAddressStreet";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantApetiloImage";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantName";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantPhones";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantSlug";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "siteName";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "state";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "userLoyalty";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Promotions_Loyalty_Types_UserLoyalty.showUserLoyalty)))(showOrderSummaryState))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(Data_Show.showString))(Restaumatic_Restaurant_Types_Id.showRestaurantId))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(Data_Show.showString))(Restaumatic_Orders_RPC_Sites_OrderInfo.showOrderInfo))))({
        reflectSymbol: function () {
            return "GetOrderSummaryResponse";
        }
    }))
};
var unscrambleDecodeGetOrderSummaryResponse = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGetOrderSummaryResponse)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "orderInfo";
        }
    })(Restaumatic_Orders_RPC_Sites_OrderInfo.unscrambleDecodeOrderInfo)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "restaurantAddressCity";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "restaurantAddressPostCode";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "restaurantAddressStreet";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "restaurantApetiloImage";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(Restaumatic_Restaurant_Types_Id.udecodeRestaurantId)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "restaurantName";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "restaurantPhones";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "restaurantSlug";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "siteName";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "state";
        }
    })(unscrambleDecodeOrderSummaryState)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "userLoyalty";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Promotions_Loyalty_Types_UserLoyalty.unscrambleDecodeUserLoyalty))(Unscramble.decodeRecordNil))))))))))))))))(Unscramble_Generic.defaultOptions)
};
var genericGetOrderSummaryRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGetOrderSummaryRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetOrderSummaryRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "orderId";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Orders_Types.showOrderUUID))))({
        reflectSymbol: function () {
            return "GetOrderSummaryRequest";
        }
    }))
};
var unscrambleDecodeGetOrderSummaryRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGetOrderSummaryRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "orderId";
        }
    })(Restaumatic_Orders_Types.unscrambleDecodeOrderUUID)(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var genericGetCheckoutInfoRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGetCheckoutInfoRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetCheckoutInfoRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "isQrWaiterOrder";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "locale";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Restaurant_Types_Id.showRestaurantId))(Restaumatic_Locales.showLocale))(Data_Show.showBoolean))))({
        reflectSymbol: function () {
            return "GetCheckoutInfoRequest";
        }
    }))
};
var unscrambleDecodeGetCheckoutInfoRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGetCheckoutInfoRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "isQrWaiterOrder";
        }
    })(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "locale";
        }
    })(Restaumatic_Locales.udecodeLocale)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(Restaumatic_Restaurant_Types_Id.udecodeRestaurantId)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var genericFulfillmentTimeChoice = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showFulfillmentTimeChoice = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericFulfillmentTimeChoice)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "label";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "value";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Data_UTCTime.showUTCTime)))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "FulfillmentTimeChoice";
        }
    }))
};
var unscrambleDecodeFulfillmentTimeChoice = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericFulfillmentTimeChoice)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "label";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Data_UTCTime.unscrambleDecodeUTCTime))(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var genericCheckoutInfo = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCheckoutInfo = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCheckoutInfo)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "companyCity";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "companyName";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "country";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "fulfillmentMethods";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "fulfillmentTimes";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "paylanePublicApiKey";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "paymentMethods";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantName";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "signedIn";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showBoolean))(Data_Show.showString))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Orders_Types_PaymentMethod.showPaymentMethod)))(Data_Show.showString))(/* #__PURE__ */ Data_Show.showArray(showFulfillmentTimeChoice)))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Orders_Types_FulfillmentMethodType.showFulfillmentMethodType)))(Restaumatic_TypesGen.showCountry))(Data_Show.showString))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "CheckoutInfo";
        }
    }))
};
var unscrambleDecodeCheckoutInfo = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCheckoutInfo)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "companyCity";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "companyName";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "country";
        }
    })(Restaumatic_TypesGen.unscrambleDecodeCountry)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "fulfillmentMethods";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Orders_Types_FulfillmentMethodType.unscrambleDecodeFulfillmentMethodType))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "fulfillmentTimes";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeFulfillmentTimeChoice))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "paylanePublicApiKey";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "paymentMethods";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Orders_Types_PaymentMethod.unscrambleDecodePaymentMethod))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "restaurantName";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "signedIn";
        }
    })(Unscramble.decodeBoolean1)(Unscramble.decodeRecordNil)))))))))))))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodePlaceOrderResponse = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericPlaceOrderResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Errors";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode)))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Redirect";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "url";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "orderUUID";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_Types.encodeOrderUUID))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ExternalRedirect";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "url";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "orderUUID";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_Types.encodeOrderUUID))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PaymentForm";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "orderUUID";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_Types.encodeOrderUUID)))({
        reflectSymbol: function () {
            return "form";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_Payments_Types.encodeForm)))))))))(encodingOpts)
};
var encodePlaceOrderRequest = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericPlaceOrderRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PlaceOrderRequest";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "paymentChannel";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Orders_Payments_Dotpay_Types.encodeChannelId))))({
        reflectSymbol: function () {
            return "payment";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Orders_Payments_Types.encodePaymentRequest))))({
        reflectSymbol: function () {
            return "origin";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "checkout";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_Checkout_Types.encodeCheckoutRequest))))))(encodingOpts)
};
var encodeOrderSummaryState = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericOrderSummaryState)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Placed";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "WaitingForPayment";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "WaitingForDispatch";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "openAt";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "WaitingForConfirmation";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Completed";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsProduct(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Time_Local.encodeTZLabel)))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_UTCTime.encodeUTCTime)))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Cancelled";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))))))))(encodingOpts)
};
var encodeGetOrderSummaryResponse = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericGetOrderSummaryResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "GetOrderSummaryResponse";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "userLoyalty";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Promotions_Loyalty_Types_UserLoyalty.encodeUserLoyalty))))({
        reflectSymbol: function () {
            return "state";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeOrderSummaryState)))({
        reflectSymbol: function () {
            return "siteName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "restaurantSlug";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "restaurantPhones";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "restaurantName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.encodeRestaurantId)))({
        reflectSymbol: function () {
            return "restaurantApetiloImage";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "restaurantAddressStreet";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "restaurantAddressPostCode";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "restaurantAddressCity";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "orderInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_RPC_Sites_OrderInfo.encodeOrderInfo))))))(encodingOpts)
};
var encodeGetOrderSummaryRequest = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericGetOrderSummaryRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "GetOrderSummaryRequest";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "orderId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_Types.encodeOrderUUID))))))(encodingOpts)
};
var encodeGetCheckoutInfoRequest = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericGetCheckoutInfoRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "GetCheckoutInfoRequest";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.encodeRestaurantId)))({
        reflectSymbol: function () {
            return "locale";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Locales.encodeLocale)))({
        reflectSymbol: function () {
            return "isQrWaiterOrder";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode))))))(encodingOpts)
};
var encodeFulfillmentTimeChoice = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericFulfillmentTimeChoice)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "FulfillmentTimeChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Data_UTCTime.encodeUTCTime))))({
        reflectSymbol: function () {
            return "label";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(encodingOpts)
};
var encodeCheckoutInfo = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericCheckoutInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CheckoutInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "signedIn";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
        reflectSymbol: function () {
            return "restaurantName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "paymentMethods";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Orders_Types_PaymentMethod.encodePaymentMethod))))({
        reflectSymbol: function () {
            return "paylanePublicApiKey";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "fulfillmentTimes";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeFulfillmentTimeChoice))))({
        reflectSymbol: function () {
            return "fulfillmentMethods";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Orders_Types_FulfillmentMethodType.encodeFulfillmentMethodType))))({
        reflectSymbol: function () {
            return "country";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_TypesGen.encodeCountry)))({
        reflectSymbol: function () {
            return "companyName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "companyCity";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(encodingOpts)
};
var decodePlaceOrderResponse = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericPlaceOrderResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Errors";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode))))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Redirect";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "url";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "orderUUID";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Orders_Types.decodeOrderUUID))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ExternalRedirect";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "url";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "orderUUID";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Orders_Types.decodeOrderUUID))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PaymentForm";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "orderUUID";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Orders_Types.decodeOrderUUID))())({
        reflectSymbol: function () {
            return "form";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Orders_Payments_Types.decodeForm))())))(Foreign_Generic_Class.genericCountArgsArgument)))))(encodingOpts)
};
var decodePlaceOrderRequest = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericPlaceOrderRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PlaceOrderRequest";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "paymentChannel";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Orders_Payments_Dotpay_Types.decodeChannelId)))())({
        reflectSymbol: function () {
            return "payment";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Orders_Payments_Types.decodePaymentRequest)))())({
        reflectSymbol: function () {
            return "origin";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "checkout";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Orders_Checkout_Types.decodeCheckoutRequest))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeOrderSummaryState = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericOrderSummaryState)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Placed";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "WaitingForPayment";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "WaitingForDispatch";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "openAt";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "WaitingForConfirmation";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Completed";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsProduct(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Time_Local.decodeTZLabel)))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_UTCTime.decodeUTCTime))))(/* #__PURE__ */ Foreign_Generic_Class.genericCountArgsProduct(Foreign_Generic_Class.genericCountArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument)))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Cancelled";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode))))(Foreign_Generic_Class.genericCountArgsArgument)))))))(encodingOpts)
};
var decodeGetOrderSummaryResponse = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericGetOrderSummaryResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "GetOrderSummaryResponse";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "userLoyalty";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Promotions_Loyalty_Types_UserLoyalty.decodeUserLoyalty)))())({
        reflectSymbol: function () {
            return "state";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeOrderSummaryState))())({
        reflectSymbol: function () {
            return "siteName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "restaurantSlug";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "restaurantPhones";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "restaurantName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.decodeRestaurantId))())({
        reflectSymbol: function () {
            return "restaurantApetiloImage";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "restaurantAddressStreet";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "restaurantAddressPostCode";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "restaurantAddressCity";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "orderInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Orders_RPC_Sites_OrderInfo.decodeOrderInfo))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeGetOrderSummaryRequest = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericGetOrderSummaryRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "GetOrderSummaryRequest";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "orderId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Orders_Types.decodeOrderUUID))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeGetCheckoutInfoRequest = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericGetCheckoutInfoRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "GetCheckoutInfoRequest";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.decodeRestaurantId))())({
        reflectSymbol: function () {
            return "locale";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Locales.decodeLocale))())({
        reflectSymbol: function () {
            return "isQrWaiterOrder";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeFulfillmentTimeChoice = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericFulfillmentTimeChoice)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "FulfillmentTimeChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Data_UTCTime.decodeUTCTime)))())({
        reflectSymbol: function () {
            return "label";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeCheckoutInfo = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericCheckoutInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CheckoutInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "signedIn";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
        reflectSymbol: function () {
            return "restaurantName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "paymentMethods";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Orders_Types_PaymentMethod.decodePaymentMethod)))())({
        reflectSymbol: function () {
            return "paylanePublicApiKey";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "fulfillmentTimes";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeFulfillmentTimeChoice)))())({
        reflectSymbol: function () {
            return "fulfillmentMethods";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Orders_Types_FulfillmentMethodType.decodeFulfillmentMethodType)))())({
        reflectSymbol: function () {
            return "country";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_TypesGen.decodeCountry))())({
        reflectSymbol: function () {
            return "companyName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "companyCity";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
export {
    Placed,
    WaitingForPayment,
    WaitingForDispatch,
    WaitingForConfirmation,
    Completed,
    Cancelled,
    Errors,
    Redirect,
    ExternalRedirect,
    PaymentForm,
    CheckoutInfo,
    FulfillmentTimeChoice,
    GetCheckoutInfoRequest,
    GetOrderSummaryRequest,
    GetOrderSummaryResponse,
    PlaceOrderRequest,
    encodingOpts,
    genericOrderSummaryState,
    showOrderSummaryState,
    eqOrderSummaryState,
    decodeOrderSummaryState,
    unscrambleDecodeOrderSummaryState,
    encodeOrderSummaryState,
    genericPlaceOrderResponse,
    showPlaceOrderResponse,
    eqPlaceOrderResponse,
    decodePlaceOrderResponse,
    unscrambleDecodePlaceOrderResponse,
    encodePlaceOrderResponse,
    genericCheckoutInfo,
    showCheckoutInfo,
    eqCheckoutInfo,
    decodeCheckoutInfo,
    unscrambleDecodeCheckoutInfo,
    encodeCheckoutInfo,
    newtypeCheckoutInfo,
    hasFieldCheckoutInfo,
    genericFulfillmentTimeChoice,
    showFulfillmentTimeChoice,
    eqFulfillmentTimeChoice,
    decodeFulfillmentTimeChoice,
    unscrambleDecodeFulfillmentTimeChoice,
    encodeFulfillmentTimeChoice,
    newtypeFulfillmentTimeChoice,
    hasFieldFulfillmentTimeChoice,
    genericGetCheckoutInfoRequest,
    showGetCheckoutInfoRequest,
    eqGetCheckoutInfoRequest,
    decodeGetCheckoutInfoRequest,
    unscrambleDecodeGetCheckoutInfoRequest,
    encodeGetCheckoutInfoRequest,
    newtypeGetCheckoutInfoRequest,
    hasFieldGetCheckoutInfoRequest,
    rpcMethodNameGetCheckoutInfoRequest,
    genericGetOrderSummaryRequest,
    showGetOrderSummaryRequest,
    eqGetOrderSummaryRequest,
    decodeGetOrderSummaryRequest,
    unscrambleDecodeGetOrderSummaryRequest,
    encodeGetOrderSummaryRequest,
    newtypeGetOrderSummaryRequest,
    hasFieldGetOrderSummaryRequest,
    rpcMethodNameGetOrderSummaryRequest,
    genericGetOrderSummaryResponse,
    showGetOrderSummaryResponse,
    eqGetOrderSummaryResponse,
    decodeGetOrderSummaryResponse,
    unscrambleDecodeGetOrderSummaryResponse,
    encodeGetOrderSummaryResponse,
    newtypeGetOrderSummaryResponse,
    hasFieldGetOrderSummaryResponse,
    genericPlaceOrderRequest,
    showPlaceOrderRequest,
    eqPlaceOrderRequest,
    decodePlaceOrderRequest,
    unscrambleDecodePlaceOrderRequest,
    encodePlaceOrderRequest,
    newtypePlaceOrderRequest,
    hasFieldPlaceOrderRequest,
    rpcMethodNamePlaceOrderRequest
};
//# sourceMappingURL=index.js.map
